// @flow weak

import _ from 'lodash/fp';
import uuid from 'uuid';
import {GET, POST} from '../helpers/request';
import {addNotification} from './notification';
import {FILE_UPLOAD, ABORT_UPLOAD} from '../middleware/fileUploader';

export const GET_REQUEST = '@projectList/GET_REQUEST';
export const GET_SUCCESS = '@projectList/GET_SUCCESS';
export const GET_FAILURE = '@projectList/GET_FAILURE';

export const FILTER = '@projectList/FILTER';
export const SORT = '@projectList/SORT';

export const IMPORT_REQUEST = '@projectList/IMPORT_REQUEST';
export const IMPORT_SUCCESS = '@projectList/IMPORT_SUCCESS';
export const IMPORT_FAILURE = '@projectList/IMPORT_FAILURE';
export const TOGGLE_IMPORT_DIALOG = '@projectList/TOGGLE_IMPORT_DIALOG';
export const UPLOAD_FILE = '@projectList/UPLOAD_FILE';
export const REMOVE_FILE = '@projectList/REMOVE_FILE';
export const ABORT_FILE_UPLOAD = '@projectList/ABORT_FILE_UPLOAD';
export const FILE_UPLOADED = '@projectList/FILE_UPLOADED';

const projectsRequest = () => ({
  type: GET_REQUEST,
});

const projectsSuccess = projects => ({
  type: GET_SUCCESS,
  projects,
});

const projectsFailure = error => ({
  type: GET_FAILURE,
  error,
});

const projectsImportRequest = () => ({
  type: IMPORT_REQUEST,
});

const projectsImportSuccess = () => ({
  type: IMPORT_SUCCESS,
});

const projectsImportFailure = error => ({
  type: IMPORT_FAILURE,
  error,
});

export const fetchProjects = () => async dispatch => {
  dispatch(projectsRequest());
  try {
    const projects = await GET({endpoint: '/projects'}, dispatch);
    dispatch(projectsSuccess(projects));
  } catch (err) {
    dispatch(projectsFailure(err));
  }
};

export const filterProjects = filter => ({
  type: FILTER,
  ...filter,
});

export const toggleImportDialog = show => ({
  type: TOGGLE_IMPORT_DIALOG,
  show,
});

const dispatchNotifications = (dispatch, importInfo) => {
  if (!importInfo.length) {
    return;
  }
  const newProjects = _.filter(p => p.isNew, importInfo);
  if (!!newProjects.length) {
    _.forEach(project => {
      const multipleApartments = project.newApartments > 1;
      const multipleUsers = project.newUsers > 1;
      dispatch(addNotification(
        `${project.name} skapat med ` +
        `${project.newApartments} lägenhet${multipleApartments ? 'er' : ''} ` +
        `och ${project.newUsers} beställning${multipleUsers ? 'ar' : ''}`
      ));
    }, newProjects);
  }
  const updatedProjects = _.filter(p => !p.isNew && (!!p.newUsers || !!p.updatedUsers), importInfo);
  if (!!updatedProjects.length) {
    _.forEach(project => {
      let message = '';
      if (!!project.newUsers) {
        const multiple = project.newUsers > 1;
        message = `${project.newUsers} ny${multiple ? 'a' : ''} ` +
          `beställning${multiple ? 'ar' : ''}`;
      }
      if (!!project.updatedUsers) {
        const multiple = project.updatedUsers > 1;
        message += `${!!project.newUsers ? ' och ' : ''}` +
          `${project.updatedUsers} uppdaterad${multiple ? 'e' : ''} användare`;
      }
      if (!_.isEmpty(message)) {
        dispatch(addNotification(`${message} för ${project.name}`));
      }
    }, updatedProjects);
  }
};

export const importProjects = file => async dispatch => {
  dispatch(projectsImportRequest());
  try {
    const importInfo = await POST({
      endpoint: `/projects/import/${file.id}`,
    }, dispatch);
    dispatch(projectsImportSuccess());
    dispatch(toggleImportDialog(false));
    dispatch(fetchProjects());
    dispatchNotifications(dispatch, importInfo);
  } catch (err) {
    dispatch(projectsImportFailure(err));
  }
};

const fileUploaded = (tempId, metadata) => ({
  type: FILE_UPLOADED,
  tempId,
  metadata,
});

export const uploadFile = file => ({
  type: UPLOAD_FILE,
  tempId: uuid.v4(),
  [FILE_UPLOAD]: {
    file,
    success: fileUploaded,
  },
});

export const removeFile = () => ({
  type: REMOVE_FILE,
});

export const abortUpload = tempId => ({
  type: ABORT_FILE_UPLOAD,
  tempId,
  [ABORT_UPLOAD]: true,
});

export const sortItems = sorter => ({
  type: SORT,
  sorter,
});



// WEBPACK FOOTER //
// ./src/actions/projectList.js